export default ({ route }, inject) => {
  inject('isStyleguide', () => route.fullPath.includes('styleguide'))
}
